import React, { useEffect, useState } from 'react';

const DEFAULT_LOADER_SRC = '/generic-loader.gif';
const LOADING_LONGER_THAN_EXPECTED_TIMEOUT_MS = 7000; // 7 seconds
const LOADING_ISSUE_TIMEOUT_MS = 60000; // 60 seconds

const Loading = ({ src, message }: { src: string; message?: string }) => (
  <div className="loading fullpage">
    <img src={src} alt="loading" width="100" height="100" />
    {message && <p>{message}</p>}
  </div>
);

const LoadingWrapper = () => {
  const url = new URL(window.location.toString());

  const [message, setMessage] = useState('');

  useEffect(() => {
    const timeout = setTimeout(() => {
      setMessage(
        'Loading is taking longer than expected, please hang tight while we fetch your experience...',
      );
    }, LOADING_LONGER_THAN_EXPECTED_TIMEOUT_MS);

    return () => {
      clearTimeout(timeout);
    };
  });

  useEffect(() => {
    const timeout = setTimeout(() => {
      setMessage(
        'We appear to have run into an issue while loading your experience, please try refreshing the page.',
      );
    }, LOADING_ISSUE_TIMEOUT_MS);

    return () => {
      clearTimeout(timeout);
    };
  });

  const loaderURL = url.searchParams.get('loader');
  const loaderSrc = loaderURL || DEFAULT_LOADER_SRC;

  return <Loading src={loaderSrc} message={message} />;
};

export default LoadingWrapper;
